<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Capawesome Cloud is easy to set up and integrates seamlessly with your existing Capacitor app'
    "
    [icon]="'@tui.route'"
    [subtitle]="'How it works'"
    [title]="'Get started in 3 simple steps'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
    <div
      class="flex flex-1 flex-col justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <span class="text-xl font-bold md:text-2xl">1. Create a new project</span>
      <p class="text-pretty text-lg">
        Start by creating a new project in the Capawesome Cloud Console. Just
        enter your project name, create your first channel and you're ready to
        go.
      </p>
      <a
        appearance="flat"
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="consoleBaseUrl"
        target="_blank"
        data-umami-event="landing-how-it-works-get-started-button"
      >
        Get started
      </a>
    </div>
    <div
      class="flex flex-1 flex-col justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <span class="text-xl font-bold md:text-2xl"
        >2. Install the Live Update SDK</span
      >
      <p class="text-pretty text-lg">
        Install the Live Update SDK in your Capacitor app and configure the
        plugin to connect to your Capawesome Cloud project.
      </p>
      <a
        appearance="flat"
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="docsUrl"
        target="_blank"
        data-umami-event="landing-how-it-works-install-sdk-button"
      >
        Read the docs
      </a>
    </div>
    <div
      class="flex flex-1 flex-col justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <span class="text-xl font-bold md:text-2xl"
        >3. Publish your first update</span
      >
      <p class="text-pretty text-lg">
        Publish your first live update to your app and see the magic happen.
        Just upload your changes via the Capawesome Cloud Console or the
        Capawesome CLI.
      </p>
      <a
        appearance="flat"
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="docsUrl"
        target="_blank"
        data-umami-event="landing-how-it-works-publish-update-button"
      >
        Read the docs
      </a>
    </div>
  </div>
</section>
